import '../Main.css';
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaLinkedin, FaInstagram } from "react-icons/fa";
import { MdEmail, MdLocationOn } from "react-icons/md";
import { FaRegCopyright } from "react-icons/fa6";

function Footer() {
  return (
    <div id="container-9">
      {/* Centered Watermark Background */}
      <div className="footer-watermark">
        <div className="watermark-content">
          <img src="/Image/logo.png" alt="" className="watermark-logo" />
          <h2>ZustGo</h2>
          <p>Your needs, faster</p>
        </div>
      </div>

      <div className="footer-content">
        {/* Top Section - 4 Columns */}
        <div className="footer-grid">
          {/* Column 1: Brand & Address & Download */}
          <div className="footer-col">
            <h2 className="footer-brand">ZustGo</h2>
            <div className="footer-address">
              <MdLocationOn className="address-icon" size={24} />
              <p>
                22 VKA Nagar<br />
                1st Floor Ammapettai<br />
                Chidambaram, Tamil Nadu 608401
              </p>
            </div>


          </div>

          {/* Column 2: Get in Touch & Socials */}
          <div className="footer-col">
            <h2 className="footer-title">Get in Touch</h2>
            <div className="contact-info">
              <div className="contact-item">
                <FaPhoneAlt size={16} />
                <a href="tel:+919786221122">+91 97862 21122</a>
              </div>
              <div className="contact-item">
                <MdEmail size={18} />
                <a href="mailto:zustgoapp@gmail.com">zustgoapp@gmail.com</a>
              </div>
            </div>
            <div className="social-icons">
              <a href="https://www.linkedin.com/company/zustgo" target="_blank" rel="noopener noreferrer">
                <FaLinkedin size={20} />
              </a>
              <a href="https://www.instagram.com/zustgo_delivery" target="_blank" rel="noopener noreferrer">
                <FaInstagram size={20} />
              </a>
            </div>
          </div>

          {/* Column 3: Navigation */}
          <div className="footer-col">
            <h2 className="footer-title">Navigation</h2>
            <ul className="footer-links">
              <li><Link to="/aboutus">About Us</Link></li>
              <li><Link to="/contactus">Contact Us</Link></li>
              <li><Link to="/popularmenu">Popular Menu</Link></li>
            </ul>
          </div>

          {/* Column 4: Partnership */}
          <div className="footer-col">
            <h2 className="footer-title">Partnership</h2>
            <ul className="footer-links">
              <li><Link to="/partner">Become a Merchant Partner</Link></li>
              <li><Link to="/driver">Become a Driver</Link></li>
              <li><Link to="/franchisee">Become a Franchisee</Link></li>
            </ul>
          </div>
        </div>

        {/* Cities and Download sections side-by-side */}
        <div className="footer-middle-section">
          <div className="footer-cities">
            <h2>Cities We Deliver To</h2>
            <p>Sivagangai / Kalayarkoil / Karaikudi / Devakottai / Tondi / Manamadurai</p>
          </div>
          <div className="footer-download-section">
            <h3 className="download-title">Download ZustGo</h3>
            <a href="https://play.google.com/store/apps/details?id=com.zustgo.customer" target="_blank" rel="noopener noreferrer" className="playstore-link">
              <img src="/Image/playstore.png" alt="Get it on Google Play" className="playstore-badge" />
            </a>
          </div>
        </div>

        {/* Bottom Bar: Copyright & Policy Links */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <FaRegCopyright size={14} style={{ marginRight: '5px' }} />
            <span>2026 ZustGo All rights reserved.</span>
          </div>
          <div className="footer-bottom-right">
            <div className="footer-bottom-links">
              <Link to="/refund-policy">Refund Policy</Link>
              <Link to="/terms">Terms of Use</Link>
              <a
                href="/privacy_policy.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
